import { useIntl } from 'react-intl';

import { GatewayChatLayout, useGatewayChatPage } from '@verantos-dev/feature-agent-chat';

export const ResearchAssistantPage = () => {
  const intl = useIntl();

  const title = intl.formatMessage({
    id: 'projects.researchAssistant.chatWindow.title',
  });

  const { layoutProps } = useGatewayChatPage({
    baseOptions: {
      isOwner: true,
    },
    titleFallback: title,
    disclaimerText: intl.formatMessage({
      id: 'projects.researchAssistant.chatWindow.disclaimer',
      defaultMessage: 'Research assistant is in preview. Verify responses before acting.',
    }),
    showProtocolMonitor: true,
    fileUploadConfigOverride: null,
  });

  return <GatewayChatLayout {...layoutProps} />;
};

export default ResearchAssistantPage;
